export const enUS = {
  // Deposit related
  deposit: {
    title: 'Deposit',
    chain: 'Chain',
    asset: 'Asset',
    amount: 'Amount',
    available: 'Available',
    equity: 'Equity',
    confirmDeposit: 'Confirm Deposit',
    switchNetwork: 'Switch Network',
    max: 'Max',
    arrivalTime: 'Arrival Time',
    minDeposit: 'Minimum Deposit Amount',
    minDepositParsed: 'Min. Deposit {{amount}} {{token}}',
    maxDeposit: 'Maximum Deposit Amount',
    depositTipFor25w:
      'The maximum amount per deposit is 200,000. If your deposit exceeds 200,000, please use the Ethereum chain.',
    depositAllTip:
      'Only {{coin}} ({{v}}) is supported for deposits to this address. \n If the deposit amount exceeds 200,000, there may be a delay in the arrival time. Please be patient.',
    enableSystemProWithToken: 'Enable {{token}} on {{network}}',
    enableTokenDesc:
      'You must enable {{token}} the first time you deposit on {{network}}.',
    enableWithToken: 'Enable {{token}}',
    arrivaltimeTooltip1:
      'The funds will arrive in approximately {{v}} minutes (after reaching {{v1}} block confirmations).',
    arrivaltimeTooltip2:
      'Estimated time is calculated based on historical data and is for reference only. Network congestion may result in longer actual arrival times.',
    arrivalEstimated: '≈ {{v}} minutes',
    availableDesc:
      'The maximum amount you can deposit. When the available balance is 0 or negative, deposits cannot be made.',
    noPrivateKeyWalletWarning:
      'Do not use keyless wallets to make deposits. Depositing with a keyless wallet may result in irreversible loss of funds.',
    layerZeroDepositTip:
      'The system will complete your deposit via LayerZero based on the actual deposit conditions.',
    layerZeroDepositTipExceedPool:
      'Since the deposit amount exceeds the pool, your deposit will be completed via LayerZero.',
    layerZeroDepositTipGte200k:
      'Since the deposit amount is greater than or equal to 200,000 USDT, your deposit will be completed via LayerZero.',
    layerZeroDepositButton: 'Deposit with LayerZero',
  },
  withdraw: {
    noticeDesc:
      'Normal withdrawals are a two-step process. The current step initiates your withdrawal request and will be processed on Layer 2. Once your funds are ready (can take up to 4 hours), you will receive a notification to withdraw funds to your wallet. Due to chain synchronization and other factors, the duration may take up to 48 hours. You are responsible for any transaction gas fees.',
    crossChainTips:
      "Cross-chain withdrawals require verification at L2 (via ZK proofs) and the withdrawal process may take up to 2 hours. Sufficient funds in the corresponding chain's asset pool are required to process cross-chain withdrawals. Gas fees will also be incurred. edgeX will charge a fee to cover this.",
    commonWithdraw: 'Withdrawal FAQ',
    withdraw: 'Withdraw',
    speed: 'Speed',
    confirmWithdraw: 'Confirm Withdrawal',
    speedNote: 'Processing Times:',
    speedNoteSpeed1: 'Approx. 8 Minutes',
    speedNoteSpeed2: 'Approx. 2-4 Hours',
    speedNoteSpeed3: 'Approx. 4 Hours',
    receiverAddress: 'Receiver Address',
    fee: 'Fee',
    feeRate: 'Fee Rate',
    withdrawlAmount: 'Withdrawal amount',
    amountToReceive: 'Amount to Receive',
    invalidReceiverAddress: 'Address cannot be empty',
    availableDesc:
      'The maximum amount you can withdraw. When the available balance is 0 or negative, withdrawals cannot be made.',
    feeCalculationTip:
      'Withdrawal fees are calculated by multiplying the withdrawal amount by the fee rate, with a minimum of 1 USDT/USDC. The fee rate may be adjusted based on actual on-chain conditions.',
    crossChainPoolBalance: 'Cross-chain pool balance',
    poolBalance: 'Pool balance',
    poolBalanceInsufficientTip:
      'The withdrawal amount exceeds the fund pool balance, and the withdrawal cannot be processed. Please select an option with a sufficient fund pool balance.',
  },
  account: {
    title: 'Account',
    perpetual: 'Perpetual Account',
    spot: 'Spot Account',
  },
}

export default enUS
